import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// While a video is still processing (no H.264 URL yet), poll the media record so the UI
// swaps in the playable version the moment transcoding finishes — no manual refresh needed.
// Returns the latest known media object.
export const useVideoPoll = (initial) => {
  const [media, setMedia] = useState(initial);
  const idRef = useRef(initial?.id);

  useEffect(() => {
    if (initial?.id !== idRef.current) { idRef.current = initial?.id; setMedia(initial); }
  }, [initial]);

  useEffect(() => {
    const m = media;
    if (!m || m.media_type !== "video" || m.cloud_video_url || m.video_failed) return;
    let n = 0, stopped = false, timer = null;
    const poll = async () => {
      if (stopped) return;
      n += 1;
      try {
        const { data } = await api.get(`/media/${m.id}`);
        if (data && (data.cloud_video_url || data.video_failed || !data.video_processing)) {
          setMedia(data);
          return; // resolved -> stop
        }
      } catch (e) { /* keep trying */ }
      if (n < 40) timer = setTimeout(poll, 8000); // ~5 min of polling, then give up
    };
    timer = setTimeout(poll, 8000);
    return () => { stopped = true; if (timer) clearTimeout(timer); };
  }, [media]);

  return media;
};
